import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledHeadTableCell = styled(TableCell)(({ theme }) => ({
 fontWeight: 'bold',
 fontSize: '15px',
 textAlign: 'center',
 color: 'white',
 background: `linear-gradient(to bottom, ${theme.palette.primary.main} 95%, #b0b0b0 96%, #f0f0f0 100%)`,
}));

const HeadTableCell = ({ 
 children, 
 wxs, 
 wmd, 
 wlg,
 wxl,
 fontxs,
 fontmd,
 fontlg,
 fontxl,
 sx = {}, 
 ...props 
}) => {
 const responsiveStyles = {};
 
 // Width styles
 if (wxs || wmd || wlg || wxl) {
   responsiveStyles.width = {};
   if (wxs) responsiveStyles.width.xs = wxs;
   if (wmd) responsiveStyles.width.md = wmd;
   if (wlg) responsiveStyles.width.lg = wlg;
   if (wxl) responsiveStyles.width.xl = wxl;
 }

 // Font size styles
 if (fontxs || fontmd || fontlg || fontxl) {
   responsiveStyles.fontSize = {};
   if (fontxs) responsiveStyles.fontSize.xs = fontxs;
   if (fontmd) responsiveStyles.fontSize.md = fontmd;
   if (fontlg) responsiveStyles.fontSize.lg = fontlg;
   if (fontxl) responsiveStyles.fontSize.xl = fontxl;
 }

 const combinedSx = {
   ...responsiveStyles,
   ...sx,
 };

 return (
   <StyledHeadTableCell sx={combinedSx} {...props}>
     {children}
   </StyledHeadTableCell>
 );
};

export default HeadTableCell;